'use client'

import { useMemo } from 'react'

import { useSidebar } from '@/components/ui/sidebar'

export const useSidebarVisibility = () => {
  const { state, isMobile } = useSidebar()

  return useMemo(() => isMobile || state === 'expanded', [state, isMobile])
}
